import { InjectionToken } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { signaturReducer, SignaturState } from './signatur.reducer';
import { ReducerConfig } from '@schir-int-client/test-helpers';

export const signaturFeatureState = 'SignatureState';
export const signaturReducerInjectionToken = new InjectionToken<ActionReducerMap<SignaturRootState>>(
	'Registered SignaturReducer'
);

export interface SignaturRootState {
	signatur: SignaturState;
}

export function getSignaturReducer(): ActionReducerMap<SignaturRootState> {
	return {
		signatur: signaturReducer,
	};
}

export const signatureReducerConfig: ReducerConfig<SignaturRootState> = {
	reducers: getSignaturReducer(),
	injectionToken: signaturReducerInjectionToken,
};
